"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.durationTimeInMs = void 0;
exports.durationTimeInMs = 300;
